module.exports = "pegasus_template/assets/themelp1/basic/100.png";